import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

export const conferenceSchema = z.object({
  conferenceName: z.string().min(3),

  confStartDate: z.string().nullable(),
  confEndDate: z.string().nullable(),
});

export const defaultConferenceValues: DefaultValues<ConferenceSchema> = {
  conferenceName: '',
};

export type ConferenceSchema = z.infer<typeof conferenceSchema>;
